import { AppContainer, colors, ErrorMessage, PageContainer, Spinner } from 'component-library';
import { FooterPlaceholder } from './FooterPlaceholder';
import { HeaderPlaceholder } from './HeaderPlaceholder';

export const LoadingI18n = ({ error }: { error?: boolean }) => {
  return (
    <AppContainer
      backgroundColor={colors.secondary.beigeTint1}
      footer={<FooterPlaceholder />}
      header={<HeaderPlaceholder />}
    >
      <PageContainer>
        {error && (
          <ErrorMessage
            title="Site failed to load"
            link={{
              href: 'https://www.stenarecycling.com/sv/kontakta-oss/hitta-ett-kontor/',
              text: 'Contact your local Stena Recycling site',
            }}
            description="We are experiencing technical difficulties. Please try again later or contact your local Stena Recycling site for help with troubleshooting."
          />
        )}
        {!error && <Spinner size="xlarge" />}
      </PageContainer>
    </AppContainer>
  );
};
